import { useState, type FormEvent } from 'react';

import { NotAnOperatorError, useAuth } from '../auth/AuthProvider';

export function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email.trim(), password);
    } catch (cause) {
      // A wrong password and a valid-but-not-an-operator account are genuinely different problems
      // and want different words: one is "try again", the other is "this will never work".
      setError(
        cause instanceof NotAnOperatorError
          ? cause.message
          : cause instanceof Error
            ? cause.message
            : 'Could not sign you in.',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login-card" onSubmit={submit}>
        <h1>Electra Admin</h1>
        <p className="muted" style={{ marginTop: 0, marginBottom: 20 }}>
          Sign in with your Electra account.
        </p>

        {error ? (
          <div className="notice error" role="alert">
            {error}
          </div>
        ) : null}

        <label className="field">
          <span>Email</span>
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            autoComplete="username"
            required
            autoFocus
          />
        </label>

        <label className="field">
          <span>Password</span>
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        <button className="button" type="submit" disabled={busy} style={{ width: '100%' }}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
